import React from 'react';

interface SalesAnalyzerIconProps {
  size?: number;
  color?: string;
}

/**
 * Sales Analyzer Icon Component
 * @description Icon representing sales analytics and performance tracking
 */
export const SalesAnalyzerIcon: React.FC<SalesAnalyzerIconProps> = ({ 
  size = 24, 
  color = '#fff' 
}) => {
  return (
    <svg  width={size} height={size} fill="none" viewBox="0 0 24 24"><path fill={color} d="M21 2a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-7v3h4v2H6v-2h4v-3H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zM4.563 4.25A.56.56 0 0 0 4 4.813v9.375a.563.563 0 0 0 .563.562h10.875a.563.563 0 0 0 0-1.125H5.124V4.813a.56.56 0 0 0-.562-.563m10.87 1.514a.56.56 0 0 0-.393.151l-3.54 3.54-1.853-1.852a.563.563 0 0 0-.794 0L6.415 10.04a.563.563 0 0 0 .795.795l2.04-2.04 1.852 1.853a.56.56 0 0 0 .796 0l3.937-3.938a.563.563 0 0 0-.401-.946"/></svg>
  );
};

export default SalesAnalyzerIcon;

